export const creditnotes = {
  alerts: {
    missingFcFiles_one: 'De pdf voor deze creditnota is niet terug te vinden.',
    missingFcFiles_other: 'De pdf’s voor deze creditnota’s zijn niet terug te vinden.',
    successCreated: 'Je creditnota is aangemaakt.',
  },
  breadcrumb: {
    create: 'Creditnota aanmaken',
    overview: 'Creditnota’s',
  },
  create: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? Je creditnota is niet opgeslagen.',
    confirmation: {
      description:
        'Ben je zeker dat je de creditnota wilt aanmaken? Wanneer de creditnota goedgekeurd en naar je klant gestuurd is, kan je geen aanpassingen meer doen.',
      sentWithPeppol: 'Je creditnota wordt na goedkeuring via Peppol verstuurd.',
      submit: 'Ja, creditnota aanmaken',
      title: 'Je creditnota wordt naar ons gestuurd',
    },
    error: {
      title: 'Fout bij het laden van de creditnota.',
    },
    partialPaymentsWarning: {
      message_one:
        'Voor deze factuur hebben wij al een gedeeltelijke betaling van {{ payment }} ontvangen. Crediteer de factuur gerust, wij pikken het verder met je op voor de opvolging van deze betaling.',
      message_other:
        'Voor deze factuur hebben wij al gedeeltelijke betalingen van {{ payment }} ontvangen. Crediteer de factuur gerust, wij pikken het verder met je op voor de opvolging van deze betalingen.',
      title: 'Een heads-up!',
    },
    submit: 'Creditnota aanmaken',
    title: 'Nieuwe creditnota',
  },
  fields: {
    invoiceId: {
      label: 'Creditnota voor factuur',
      placeholder: 'Selecteer een factuur',
    },
    numberingSeriesId: {
      helpText: 'Het creditnotanummer zal <0>{{entryNumber}}</0> zijn.',
      tooltip: 'Dit is een preview van je creditnotanummer. Je nummer zelf is pas definitief als je de creditnota naar ons verstuurt.',
    },
    reason: {
      helpText: 'Let op: de reden is zichtbaar op de creditnota aan je klant.',
      label: 'Reden',
      placeholder: 'Vul hier je reden in',
    },
  },
  overview: {
    columns: {
      client: 'Klant',
      date: 'Datum',
      entryNumber: 'Creditnota',
      reason: 'Reden',
      status: {
        options: {
          Approved: 'Goedgekeurd',
          InReview: 'Ter goedkeuring',
        },
        sentWithPeppolTooltip: 'via Peppol',
        title: 'Status',
      },
      total: 'Gecrediteerd',
    },
    created: {
      subtitle: 'Creditnota’s',
    },
    error: {
      title: 'Fout bij het laden van je creditnota’s.',
    },
    rowActions: {
      download: 'Downloaden',
    },
  },
};
